module.exports = __webpack_public_path__ + "img/download-icon.c9591487.svg";